import { Divider, Menu, MenuItem } from "@mui/material";

// A row's actions menu. Options are { name, function(row) }; "Delete" (and
// other destructive words) show in the accent colour and sit last, after a
// divider, so they are not hit by accident.
const DESTRUCTIVE = /^(delete|remove)/i;

export default function DropDown({ open, setOpen, Listdropdown = [], row, anchorEl }) {
  const options = Listdropdown.filter((option) => option && option.name);
  const safe = options.filter((o) => !DESTRUCTIVE.test(o.name));
  const risky = options.filter((o) => DESTRUCTIVE.test(o.name));

  const choose = (option) => {
    setOpen(false);
    option.function(row);
  };

  const item = (option) => (
    <MenuItem
      key={option.name}
      onClick={() => choose(option)}
      sx={
        DESTRUCTIVE.test(option.name)
          ? { color: (t) => (t.palette.mode === "dark" ? t.palette.secondary.main : t.palette.secondary.dark) }
          : undefined
      }
    >
      {option.name}
    </MenuItem>
  );

  return (
    <Menu
      anchorEl={anchorEl}
      open={!!open && !!anchorEl}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{ sx: { minWidth: 180, maxHeight: 320 } }}
    >
      {safe.map(item)}
      {safe.length > 0 && risky.length > 0 && <Divider sx={{ my: 0.5 }} />}
      {risky.map(item)}
    </Menu>
  );
}
